import { useQuery } from '@tanstack/react-query';
import { InvitationPanel, useToast } from '@rooming/ui';
import { useInvitationSharing } from '@rooming/web-core';
import { passengerApi } from '../api';

/** The signatory shares their group's activation link from the top of their view (DR-405). Renders nothing until it knows. */
export function InvitationSection() {
  const toast = useToast();
  const invitation = useQuery({
    queryKey: ['activation-invitation'],
    queryFn: async () => (await passengerApi.activationInvitation()).data,
  });
  const { closesOnText, share, copy } = useInvitationSharing(invitation.data, window.location.origin, toast);
  if (invitation.data === undefined) return null;
  return (
    <InvitationPanel
      open={invitation.data.open}
      closedReason={invitation.data.closedReason}
      total={invitation.data.total}
      pending={invitation.data.pending}
      closesOnText={closesOnText}
      onShare={share}
      onCopy={copy}
    />
  );
}
